import { gql } from '@apollo/client';

export * from './updateBillingAddress.mutation.generated';

export const UPDATE_BILLING_ADDRESS = gql`
  mutation updateBillingAddress($billingAddress: BillingAddressInput!) {
    updateBillingAddress(input: { billingAddress: $billingAddress }) {
      success
      errors
      billingAddress {
        ...BillingAddressFragment
      }
    }
  }
`;
